import React from 'react';
import StickyTabNavigation from 'src/components/sticky-tab-nav';
import { useNavigationLinks } from './utils';

const ProductNavigation: React.VFC = () => {
  const navigationTabs = useNavigationLinks();
  const defaultActiveTabId = navigationTabs[0].id;

  return (
    <StickyTabNavigation
      defaultActiveTabId={defaultActiveTabId}
      tabs={navigationTabs}
      background
    />
  );
};

export default ProductNavigation;
